// extracted by mini-css-extract-plugin
export default {"faq-section":"style_faq-section__LipnX"};